import { Navigate } from 'react-router';
import { agentPoolsTabPath } from '@/components/agent-pools-admin/agent-pools-tabs';

export default function ProcessorAdminPage() {
  return <Navigate to={agentPoolsTabPath('processor')} replace />;
}
